module.exports = __webpack_public_path__ + "img/logo_be_vallet_pnud.cef3e72f.png";